import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=99107642&scoped=true"
import script from "./Telephone.vue?vue&type=script&lang=js"
export * from "./Telephone.vue?vue&type=script&lang=js"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=99107642&prod&lang=less"
import style1 from "./Telephone.vue?vue&type=style&index=1&id=99107642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99107642",
  null
  
)

export default component.exports